import styled from "styled-components";

export const BreadcrumbsDefaultBox = styled.div`
    display: block;
    padding: 2.25rem;
    ${({theme}) => theme.font.presets.regular};
    font-size: 1.4rem;
    background-color: ${props => props.theme.colors.backgroundDark};
    color: ${props => props.theme.colors.textLight};
    border-top: 1px solid ${props => props.theme.colors.boxBorderLight};
    border-bottom: 1px solid ${props => props.theme.colors.boxBorderLight};
`

